export default __webpack_public_path__ + "static/media/cartWhite.35ef56d8.svg";